import { types } from 'mobx-state-tree';

const FundingProps = {
  totalFunding: types.optional(types.maybeNull(types.number), null),
  numberOfFundingRounds: types.optional(types.maybeNull(types.number), null),
  lastFundingAmount: types.optional(types.maybeNull(types.number), null),
  fundingDate: types.optional(types.maybeNull(types.string), null),
  lastFundingName: types.optional(types.maybeNull(types.string), null),
};

const FundingSummary = types.model(FundingProps);

export default FundingSummary;
